// var garnier = document.getElementsByClassName('garnier-icon')[0];
// console.log("gar",garnier);
// garnier.classList.add("hide-bubbles");

var intervalId = setInterval(function() {
  var gorgias = document.getElementById('chat-button');
  var mount = document.getElementById('gorgias-chat-container');
  if(gorgias !== null){
    gorgias.classList.add("hide-bubbles");
  }
  if(mount !== null){
    mount.classList.add("hide-bubbles");
  }

  
}, 70);
